import { __extends } from "tslib";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Composites, ColorPickerInput, TextLabel } from '@wix/wix-base-ui';
import { openColorPicker } from './openColorPicker';
var BaseColorPicker = /** @class */ (function (_super) {
    __extends(BaseColorPicker, _super);
    function BaseColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleColorPickerRef = function (ref) {
            _this.colorPickerRef = ref;
        };
        _this.handleOpenColorPicker = function () {
            var _a = _this.props, SDKAdapter = _a.SDKAdapter, onChange = _a.onChange, onSiteColorsChange = _a.onSiteColorsChange, value = _a.value;
            var position = _this.getPositionOfPicker();
            openColorPicker(SDKAdapter, {
                value: value,
                onChange: onChange,
                onSiteColorsChange: onSiteColorsChange,
                position: position,
            });
        };
        return _this;
    }
    BaseColorPicker.prototype.getPositionOfPicker = function () {
        var dom = ReactDOM.findDOMNode(this.colorPickerRef);
        return dom.getBoundingClientRect();
    };
    BaseColorPicker.prototype.render = function () {
        var _a = this.props, dataHook = _a.dataHook, label = _a.label, value = _a.value;
        return (React.createElement("div", { "data-aid": dataHook, "data-hook": dataHook },
            React.createElement(Composites.ColorSelectLabeled, { automationId: "color" },
                React.createElement(TextLabel, { value: label, automationId: "label" }),
                React.createElement(ColorPickerInput, { value: value.value, ref: this.handleColorPickerRef, onClick: this.handleOpenColorPicker }))));
    };
    return BaseColorPicker;
}(React.Component));
export { BaseColorPicker };
//# sourceMappingURL=BaseColorPicker.js.map